import {useEffect, useRef, useState} from 'react'

export default function useDynamicBackground({initialState = false}: {initialState?: boolean}) {
  const [isBackgroundDark, setIsBackgroundDark] = useState(initialState)
  const lastScrollY = useRef(0)

  // Detect when dark sections overlap the nav area
  useEffect(() => {
    const sections = document.querySelectorAll('[data-nav-dark="true"]')

    const detectBackground = () => {
      const scrollY = window?.scrollY || 0
      const direction = scrollY > lastScrollY.current ? 'down' : 'up'
      lastScrollY.current = scrollY

      const navBottom = document.getElementById('header-container')?.getBoundingClientRect().bottom ?? 68

      let shouldInvert = false

      sections.forEach((section) => {
        const rect = section.getBoundingClientRect()

        if (
          (direction === 'down' && rect.top <= navBottom && rect.bottom > navBottom) ||
          (direction === 'up' && rect.top <= 5 && rect.bottom > 0) ||
          (scrollY === 0 && rect.top <= navBottom && rect.bottom > 0)
        ) {
          shouldInvert = true
        }
      })

      setIsBackgroundDark(shouldInvert)
    }

    window.addEventListener('scroll', detectBackground, {passive: true})
    detectBackground()

    return () => {
      window.removeEventListener('scroll', detectBackground)
    }
  }, [])

  return {isBackgroundDark}
}
